(() => {
  if (window.__gemlayAssuredGiftStarted) return;
  window.__gemlayAssuredGiftStarted = true;
  const attrName='Gemlay Assured Gift Box';
  const giftVariantIds=new Set(['68032048955628','68032048988396','68032049021164','68032049053932','68032049086700']);
  const root=(window.Shopify?.routes?.root || '/');
  const url=(path)=>root.replace(/\/?$/,'/')+path;
  const money=(c)=>'₹'+(c/100).toLocaleString('en-IN',{maximumFractionDigits:0});
  const giftForSubtotal=(subtotal)=>subtotal>=500000?'Pink Teddy Gift Box — Complimentary (₹5,000+ jewellery)':subtotal>=300000?'Classic Gift Box — Complimentary (₹3,000+ jewellery)':'';
  const getSubtotal=(cart)=>(cart.items||[]).reduce((s,item)=>s+(giftVariantIds.has(String(item.variant_id))?0:Number(item.final_line_price||0)),0);
  const cartGet=async()=>{const r=await fetch(url('cart.js'),{credentials:'same-origin',headers:{Accept:'application/json'}});if(!r.ok)throw new Error('Cart read failed');return r.json();};
  let running=null;
  const show=(subtotal,gift,discountSubtotal)=>{
    document.querySelectorAll('[data-gemlay-assured-gift]').forEach(el=>{
      const status=el.querySelector('[data-gemlay-gift-status]');
      if(status)status.textContent=subtotal>=500000&&discountSubtotal>=800000?'Free Teddy Gift Box + ₹500 OFF unlocked':subtotal>=500000?'Pink Teddy Gift Box included free':subtotal>=300000?'Classic Gift Box included free':'Add '+money(Math.max(0,300000-subtotal))+' more jewellery to unlock a free gift';
      const fill=el.querySelector('[data-gemlay-gift-fill]');if(fill)fill.style.width=Math.min(100,Math.max(0,discountSubtotal/800000*100))+'%';
      const first=el.querySelector('[data-gemlay-milestone-first]'),second=el.querySelector('[data-gemlay-milestone-second]');
      first?.classList.toggle('is-unlocked',subtotal>=300000);
      second?.classList.toggle('is-unlocked',subtotal>=500000);
      el.querySelector('[data-gemlay-milestone-third]')?.classList.toggle('is-unlocked',discountSubtotal>=800000);
      const image=el.querySelector('[data-gemlay-gift-image]');
      if(image)image.src=subtotal>=500000?'https://cdn.shopify.com/s/files/1/0845/6758/9100/files/gemlay-teddy-jewellery-gift-box.png?v=1793602586':'https://cdn.shopify.com/s/files/1/0845/6758/9100/files/gemlay-gift-red-rose-individual.jpg?v=1793604415';
    });
    document.querySelectorAll('[data-gemlay-free-gift-order-attribute]').forEach(el=>el.value=gift);
  };
  const sync=()=> {
    if(running)return running;
    running=(async()=>{
      const cart=await cartGet();
      const subtotal=getSubtotal(cart),gift=giftForSubtotal(subtotal);
      show(subtotal,gift,Number(cart.items_subtotal_price??cart.original_total_price??0));
      if(String(cart.attributes?.[attrName]||'')!==gift){
        const response=await fetch(url('cart/update.js'),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({attributes:{[attrName]:gift}})});
        if(!response.ok)throw new Error('Gift details could not be saved');
      }
      document.dispatchEvent(new CustomEvent('gemlay:assured-gift-updated',{detail:{gift,subtotal}}));
      return gift;
    })().catch(e=>{console.warn('[Gemlay assured gift]',e.message);return null;}).finally(()=>{running=null;});
    return running;
  };
  let timer=0;
  const schedule=(delay=150)=>{clearTimeout(timer);timer=setTimeout(sync,delay);};
  const boot=()=>{
    schedule(80);
    if(typeof window.subscribe==='function'&&window.PUB_SUB_EVENTS?.cartUpdate)window.subscribe(window.PUB_SUB_EVENTS.cartUpdate,()=>schedule(80));
    document.addEventListener('change',e=>{if(e.target.matches('cart-items input,cart-drawer-items input'))schedule(350);},true);
    document.addEventListener('click',e=>{if(e.target.closest('cart-remove-button,cart-drawer quantity-input,cart-items quantity-input,.product-form__submit'))schedule(450);},true);
    document.addEventListener('shopify:section:load',()=>schedule(100));
    document.addEventListener('submit',async e=>{
      const form=e.target;
      if(!form.matches('#cart,#CartDrawer-Form'))return;
      const submitter=e.submitter;
      if(submitter?.name!=='checkout'||form.dataset.gemlayGiftSubmitted==='true')return;
      e.preventDefault();
      await sync();
      form.dataset.gemlayGiftSubmitted='true';
      if(form.requestSubmit)form.requestSubmit(submitter);
      else form.submit();
    },true);
  };
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',boot,{once:true}):boot();
  window.GemlayAssuredGift={sync,giftForSubtotal,getSubtotal};
})();